import { DatePicker } from '@mui/lab';
import { Grid } from '@mui/material';
import { memo, useCallback } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import Foreign from '../../shared/foreign';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import { ForeignForm } from 'civil-status/view-models/accordion-generality-form';

interface TranscriptionForeignProps {
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  configuration?: string;
}

const TranscriptionForeignComponent = ({
  disabled = false,
  values,
  errors,
  touched,
  onChange,
}: TranscriptionForeignProps): React.ReactElement => {
  const onFieldForeignChange = useCallback(
    (key, value) => {
      onChange('foreign', {
        ...(values || {}).foreign,
        [key]: value,
      });
    },
    [values, onChange]
  );

  const onFieldsForeignChange = useCallback(
    (valuesNew) => {
      onChange('foreign', {
        ...(valuesNew || {}),
      });
    },
    [values, onChange]
  );

  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Nome ente *"
          aria-label="Nome ente"
          id="nameInstitution"
          name="nameInstitution"
          fullWidth
          disabled={disabled}
          helperText={errors?.nameInstitution}
          error={touched?.nameInstitution && Boolean(errors?.nameInstitution)}
          type="text"
          variant="outlined"
          value={values?.nameInstitution || ''}
          onChange={(event) => {
            onChange('nameInstitution', event.target.value);
          }}
        />
      </Grid>
      <Foreign
        disabledComponent={disabled}
        values={values?.foreign}
        onChange={onFieldForeignChange}
        onChanges={onFieldsForeignChange}
        errors={errors?.foreign as FormikErrors<ForeignForm>}
        touched={touched?.foreign as unknown as FormikTouched<ForeignForm>}
        labelState="Stato ente"
        required
        isWithLocationForeign
      />
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data formazione documento *"
          aria-label="Data formazione documento"
          value={values?.documentDateFormation || null}
          onChange={(date) => {
            onChange('documentDateFormation', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="documentDateFormation"
              fullWidth
              helperText={errors?.documentDateFormation}
              error={touched?.documentDateFormation && Boolean(errors?.documentDateFormation)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <PmiTextField
          label="Descrizione documento"
          aria-label="Descrizione documento"
          id="documentDescription"
          name="documentDescription"
          fullWidth
          disabled={disabled}
          helperText={errors?.documentDescription}
          error={touched?.documentDescription && Boolean(errors?.documentDescription)}
          type="text"
          variant="outlined"
          multiline
          value={values?.documentDescription || ''}
          onChange={(event) => {
            onChange('documentDescription', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Estremi documento *"
          aria-label="Estremi documento"
          id="documentExtremes"
          name="documentExtremes"
          fullWidth
          disabled={disabled}
          helperText={errors?.documentExtremes}
          error={touched?.documentExtremes && Boolean(errors?.documentExtremes)}
          type="text"
          variant="outlined"
          multiline
          value={values?.documentExtremes || ''}
          onChange={(event) => {
            onChange('documentExtremes', event.target.value);
          }}
        />
      </Grid>
    </Grid>
  );
};

TranscriptionForeignComponent.displayName = 'Form Transcription Foreign component';

const TranscriptionForeign = memo(TranscriptionForeignComponent);

export default TranscriptionForeign;
